// Thin Connect JSON protocol client.
// No dependency on @connectrpc/connect-web for the actual calls — just fetch.

function getCsrfToken(): string {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith("samiksh_csrf="));
  return match ? match.split("=")[1] : "";
}

export class ConnectError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = "ConnectError";
  }
}

export async function connectCall<Req extends object, Res>(
  service: string,
  method: string,
  req: Req,
): Promise<Res> {
  const resp = await fetch(`/api/v1/${service}/${method}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Connect-Protocol-Version": "1",
      "X-Samiksh-CSRF": getCsrfToken(),
    },
    body: JSON.stringify(req),
  });

  const body = await resp.json().catch(() => null);

  if (!resp.ok) {
    // Connect-Go emits errors as {"code":"...","message":"..."}; older /api error
    // responses use {"error":"..."}. Accept either, fall back to HTTP status.
    const b = body as { message?: string; error?: string; code?: string } | null;
    const msg = b?.message ?? b?.error ?? `HTTP ${resp.status}`;
    throw new ConnectError(msg, b?.code);
  }

  return body as Res;
}
